import * as PIXI from 'pixi.js';
import { isMobile } from 'react-device-detect';
import { DEFAULT_FONT_FAMILY } from '../../../constants/constants';
import { BET_POT_TEXT_STROKE_COLOR_NUM, DARK_GREENISH_BLUE_NUM } from '../../../styles/colors';
export const USERNAME_LETTER_SPACING = -1;
// completely transparent, needed for aligning foreground text (with transparent stroke) with background text
const TRANSPARENT_COLOR = 'rgba(0, 0, 0, 0)';
const USERNAME_TEXT_STYLE_BASE = {
    fontFamily: DEFAULT_FONT_FAMILY,
    fill: 0xffffff,
    letterSpacing: USERNAME_LETTER_SPACING,
    fontSize: isMobile ? 18 : 20,
    lineJoin: 'round',
    strokeThickness: 5,
    stroke: TRANSPARENT_COLOR
};
const INACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE_BASE = {
    ...USERNAME_TEXT_STYLE_BASE
};
export const INACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE = new PIXI.TextStyle(INACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE_BASE);
export const INACTIVE_USERNAME_BACKGROUND_TEXT_STYLE = new PIXI.TextStyle({
    ...INACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE_BASE,
    fill: TRANSPARENT_COLOR,
    stroke: BET_POT_TEXT_STROKE_COLOR_NUM
});
export const DIMMED_USERNAME_FOREGROUND_TEXT_STYLE = new PIXI.TextStyle({
    ...INACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE_BASE,
    fill: 0x777777
});
export const ACTIVE_TIMER_USERNAME_BACKGROUND_TEXT_STYLE = new PIXI.TextStyle({
    ...INACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE_BASE,
    stroke: DARK_GREENISH_BLUE_NUM,
    fill: DARK_GREENISH_BLUE_NUM
});
export const ACTIVE_TIMER_USERNAME_FOREGROUND_TEXT_STYLE = new PIXI.TextStyle({
    ...USERNAME_TEXT_STYLE_BASE
});
